import React from 'react'
import LoadingSpinner from '../components/LoadingSpinner'
import { PreferencesProvider } from '../features/preferences/PreferencesContext'
import { usePreferencesContext } from '../features/preferences/usePreferencesContext'
import IntlProviderWithLocale from './IntlProviderWithLocale'

const LocaleGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { state } = usePreferencesContext()

  if (state.status === 'loading') {
    return <LoadingSpinner />
  }

  return <IntlProviderWithLocale locale={state.locale}>{children}</IntlProviderWithLocale>
}

const LocalizedAppShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <PreferencesProvider>
      <LocaleGate>{children}</LocaleGate>
    </PreferencesProvider>
  )
}

export default LocalizedAppShell
